module.exports = __webpack_public_path__ + "static/media/campus_14.ea4623ac.jpg";